import { ApiTranslation } from '../../../api/entities/translation.entity';
import { UserFunction } from '../../../users/entities/user-functions.entity';
import { HttpMethod } from './http-method.entity';

export enum ApiActionState {
    Allowed = 'ALLOWED',
    Disallowed = 'DISALLOWED',
    Deferred = 'DEFERRED'
}

export interface ApiActionDisabledReason {
    Code: string;
    Value: string;
}

export interface ApiActionDefinition {
    Name: string;
    Label: string;
    Labels: ApiTranslation[];
    Description: string;
    Descriptions: ApiTranslation[];
    Function: UserFunction;
    RequiredPermissions: string[];
    Href: string;
    HttpMethod: HttpMethod;
    ContentType: string;
    EventType: string;
}

export interface ApiAction {
    Rel: string;
    Href: string;
    Method: HttpMethod;
    State: ApiActionState;
    Reasons?: ApiActionDisabledReason[];
}

export interface ExtendedApiAction extends ApiAction {
    Label: string;
}
